import script from "./AliPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./AliPlayer.vue?vue&type=script&setup=true&lang=js"

import "./AliPlayer.vue?vue&type=style&index=0&id=65f56806&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f56806"]])

export default __exports__